module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-baby-ES.1718629.png";